export const VATS = {
  25.5: { validstart: '2025-01-01', validend: '2025-12-31', title: '25,5 %' },
  24: { validstart: '2019-01-01', validend: '2024-12-31', title: '24 %', disabled: true },
  10: { validstart: '2019-01-01', validend: '2024-12-31', title: '10 %', disabled: true },
  14: { validstart: '2025-01-01', validend: '2025-12-31', title: '14 %', disabled: true },
  13.5: { validstart: '2026-01-01', validend: '2099-12-31', title: '13,5 %', default: true },
  0: { validstart: '2019-01-01', validend: '2099-12-31', title: '0 %' },
}
